<template>
  <v-app>
    <v-container :class="fontClass" class="renb-container">
      <HeaderSection/>
      <IntroSection />
      <MaterialTitle />
      <MaterialS1 />
      <MaterialS2 />
      <AboutTitle />
      <AboutS1 />
      <AboutS2 />
      <AboutS3 />
      <AboutS4 />
      <AboutS5 />
      <AboutS6 />
      <AboutS7 />
      <AboutS8 />
      <AboutS9 />
      <AboutS10 />
      <AboutS11 />
      <AboutS12 />
      <AboutS13 />
      <AboutS14 />
      <AboutS15 />
      <AboutS16 />
      <AboutS17 />
      <AboutS18 />
      <AboutS19 />
      <ListProduct  />
      <Footer />
    <button
      v-show="showScrollTopButton"
      @click="scrollToTop"
      class="scroll-to-top">
      ↑
    </button>
    </v-container>
  </v-app>
</template>
<script>
import HeaderSection from '@/components/HeaderSection.vue'
import IntroSection from '@/components/IntroSection.vue'
import ListProduct from '@/components/ListProductSection.vue'
import Footer from '@/components/FooterSection.vue'
import MaterialTitle from '@/components/MaterialTitleSection.vue'
import AboutTitle from '@/components/AboutTitleSection.vue'
import MaterialS1 from '@/components/MaterialS1.vue'
import MaterialS2 from '@/components/MaterialS2.vue'
import AboutS1 from '@/components/AboutS1.vue'
import AboutS2 from '@/components/AboutS2.vue'
import AboutS3 from '@/components/AboutS3.vue'
import AboutS4 from '@/components/AboutS4.vue'
import AboutS5 from '@/components/AboutS5.vue'
import AboutS6 from '@/components/AboutS6.vue'
import AboutS7 from '@/components/AboutS7.vue'
import AboutS8 from '@/components/AboutS8.vue'
import AboutS9 from '@/components/AboutS9.vue'
import AboutS10 from '@/components/AboutS10.vue'
import AboutS11 from '@/components/AboutS11.vue'
import AboutS12 from '@/components/AboutS12.vue'
import AboutS13 from '@/components/AboutS13.vue'
import AboutS14 from '@/components/AboutS14.vue'
import AboutS15 from '@/components/AboutS15.vue'
import AboutS16 from '@/components/AboutS16.vue'
import AboutS17 from '@/components/AboutS17.vue'
import AboutS18 from '@/components/AboutS18.vue'
import AboutS19 from '@/components/AboutS19.vue'
export default {
  name: 'App',
  components: {
    HeaderSection,
    IntroSection,
    ListProduct,
    Footer,
    MaterialTitle,
    MaterialS1,
    MaterialS2,
    AboutTitle,
    AboutS1,
    AboutS2,
    AboutS3,
    AboutS4,
    AboutS5,
    AboutS6,
    AboutS7,
    AboutS8,
    AboutS9,
    AboutS10,
    AboutS11,
    AboutS12,
    AboutS13,
    AboutS14,
    AboutS15,
    AboutS16,
    AboutS17,
    AboutS18,
    AboutS19

  },
  /* eslint-disable semi */

  data () {
    return {
      showScrollTopButton: false, // Hiển thị hoặc ẩn nút cuộn lên đầu trang,
      fontClass: this.getFontClass(this.$i18n.locale)
    }
  },
  watch: {
    '$i18n.locale' (newLocale) {
      console.log(`Locale changed to ${newLocale}`)
      this.fontClass = this.getFontClass(newLocale)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initScrollSnap()
    })
    // Gắn sự kiện cuộn để theo dõi vị trí cuộn
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    getFontClass (locale) {
      switch (locale) {
        case 'jp':
          return 'font-jp'
        case 'vn':
          return 'font-vi'
        default:
          return ''
      }
    },
    initScrollSnap () {
      document.documentElement.style.scrollSnapType = 'y mandatory'
    },
    scrollToTop () {
      history.pushState('', document.title, window.location.pathname + window.location.search)
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Cuộn mượt mà
      })
    },
    handleScroll () {
      // Kiểm tra vị trí cuộn và quyết định hiển thị nút cuộn lên đầu trang
      this.showScrollTopButton = window.scrollY > 300
    }
  }
}
</script>
<style>
.step {
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;
}
.step-1 {
   scroll-snap-align: start;
   height: 100vh!important;
}
.step-1-sub {
  position: relative;
  top: 30%;
}
.step-1-image {
  position: relative;
  top: 5%;
}

.full-height {
  height: 100vh!important;
  padding-bottom: 10px;
  padding-top: 10px;
}
.aos-init {
  opacity: 0!important; /* Thiết lập opacity ban đầu cho các phần tử */
}

.aos-animate {
  opacity: 1!important; /* Thiết lập opacity khi phần tử được cuộn vào viewport */
}
.v-application {
  height: fit-content!important;
}
.scroll-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px;
  background-color: #da792a;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s;
  width: 50px;
  height: 50px;
}
/* lam mo anh */
.image-container img {
    display: block;
    width: 100%;
    transition: opacity 1s ease-in-out;
}

.image-container::before {
    content: "";
    position: absolute;
    z-index: 9999;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.719); /* Màu mờ */
    transition: left 1s ease-in-out;
}

.image-container:hover::before {
    left: 100%;
}

.image-container:hover img {
    opacity: 1;
}
.font-jp {
  font-family: "Noto Sans JP", sans-serif;
}

.font-vi {
  font-family: Montserrat, sans-serif!important;
}
.font-vi p {
  font-family: inherit !important;
}
.font-vi .intro-section {
  font-family: Montserrat, sans-serif !important;
}
@media (min-width: 1200px) {

  .renb-container {
    max-width: 1200px;
    padding: 0!important;
  }
}
@media (max-width:960px) {
  .step {
    scroll-snap-align: unset!important;
  }
}
@media (max-width:600px) {
  .step {
    overflow: hidden!important;
  }
}

</style>
